import React from 'react';
import { formatMessageText } from './formatMessageText';

export default function MessageContent({ content }) {
  return <div className="message-formatted">{formatMessageText(content)}</div>;
}
